(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgfh-workbook-video"] && !Shopify.designMode) return;
  try {
    
function initVideoGuides(root=document){root.querySelectorAll('[data-video-guide]').forEach(guide=>{if(guide.dataset.ready)return;guide.dataset.ready='true';const video=guide.querySelector('video'),cover=guide.querySelector('button'),error=guide.querySelector('[role="status"]');cover.addEventListener('click',()=>{error.hidden=true;if(!video.getAttribute('src')){video.src=video.dataset.videoSrc;video.load()}cover.hidden=true;video.tabIndex=0;video.focus({preventScroll:true});video.play().catch(()=>{cover.hidden=false;video.tabIndex=-1;error.hidden=false;cover.focus({preventScroll:true})})});video.addEventListener('error',()=>{cover.hidden=false;video.tabIndex=-1;error.hidden=false})})}initVideoGuides();document.addEventListener('shopify:section:load',event=>initVideoGuides(event.target));

  } catch(e) { console.error(e); }
})();
})();
